'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import isStorybook from '@haaretz/s-common-utils/isStorybook';
import * as React from 'react';
import useCollectBiData from './helpers/useCollectBiData';
const BiDataContext = /*#__PURE__*/ React.createContext(undefined);
const noop = ()=>({});
let useCollectBiDataOverride = useCollectBiData;
export function BiDataContextProvider({ children }) {
    if (isStorybook()) {
        // eslint-disable-next-line react-compiler/react-compiler
        useCollectBiDataOverride = noop;
    }
    const biData = useCollectBiDataOverride();
    return /*#__PURE__*/ _jsx(BiDataContext, {
        value: biData,
        children: children
    });
}
export default function useBiDataContext() {
    const context = React.use(BiDataContext);
    if (context === undefined) {
        throw new Error('useBiDataContext must be used within a BiDataContext.');
    }
    return context;
}

//# sourceMappingURL=useBiDataContext.js.map